import { useEffect, useRef, useState } from "react";
import { CircleAlert } from "lucide-react";
import { FIREFLY_TARGET_ATTR } from "@/lib/firefly/fireflyTargetConvention";
import { ghostBtnClass } from "@/components/common/surfaceClasses";

export function AudienceDataDestinationHelpMenu() {
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e: MouseEvent) => {
      if (!rootRef.current?.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

  return (
    <div ref={rootRef} className="relative shrink-0">
      <button
        type="button"
        className={`inline-flex h-8 w-8 items-center justify-center rounded-full border text-sm ${ghostBtnClass}`}
        aria-label="Where to point Google and Meta"
        aria-expanded={open}
        aria-haspopup="dialog"
        onClick={() => setOpen((v) => !v)}
        {...{ [FIREFLY_TARGET_ATTR]: "audience-data-destination-help" }}
      >
        <CircleAlert className="h-4 w-4" aria-hidden />
      </button>
      {open ? (
        <div className="absolute right-0 z-20 mt-1 w-80 max-w-[calc(100vw-2rem)] space-y-3 rounded-xl border border-gray-200 bg-white p-3 text-sm text-gray-700 shadow-lg dark:border-zinc-700 dark:bg-zinc-900 dark:text-zinc-300">
          <p className="font-semibold text-gray-900 dark:text-zinc-100">Where to point Google and Meta</p>
          <div className="space-y-1">
            <p className="font-medium text-gray-900 dark:text-zinc-100">Google Ads</p>
            <p>
              Enable the Google feed, copy the URL (token shown once), then Google Ads → Tools → Data manager →
              Connect data source → Offline conversions → file from URL. Schedule daily. Conversion Name in the file
              must match a conversion action in that account (default Offline Shed Sales — set it under Format
              preview). One-off: Download Google CSV → Goals → Conversions → Uploads.
            </p>
          </div>
          <div className="space-y-1">
            <p className="font-medium text-gray-900 dark:text-zinc-100">Meta</p>
            <p>
              Meta does not fetch a hosted URL. Download the Meta CSV, then Events Manager → Data sources → Offline
              events → upload, or Ads Manager → Audiences → Custom audience → Customer list → upload. Enable the Meta
              feed only if another tool will pull it. CAPI push from Turbo is later.
            </p>
          </div>
        </div>
      ) : null}
    </div>
  );
}
